import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export var rts = [{
    path: '/',
    name: 'HelloWorld',
    component: () => import('@/components/HelloWorld')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/components/About')
  },
  {
    path: '/partners',
    name: 'Partners',
    component: () => import('@/components/Partners')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/components/Home')
  },

  {
    path: '/hydro/',
    name: 'hydro',
    component: () => import('@/components/hydro/hydro'),
    children: [

      //Гідростатика
      {
        path: 'hst1',
        name: 'hst1',
        component: () => import('@/components/hydro/hst1')
      },
      {
        path: 'hst2',
        name: 'hst2',
        component: () => import('@/components/hydro/hst2')
      },
      {
        path: 'hst3',
        name: 'hst3',
        component: () => import('@/components/hydro/hst3')
      },
      {
        path: 'hst4',
        name: 'hst4',
        component: () => import('@/components/hydro/hst4')
      },
      {
        path: 'hst5',
        name: 'hst5',
        component: () => import('@/components/hydro/hst5')
      },

      //Гідродинаміка
      {
        path: 'dyn1',
        name: 'dyn1',
        component: () => import('@/components/hydro/dyn1')
      },
      {
        path: 'dyn2',
        name: 'dyn2',
        component: () => import('@/components/hydro/dyn2')
      },
      {
        path: 'dyn3',
        name: 'dyn3',
        component: () => import('@/components/hydro/dyn3')
      },
      {
        path: 'dyn4',
        name: 'dyn4',
        component: () => import('@/components/hydro/dyn4')
      },
      {
        path: 'dyn5',
        name: 'dyn5',
        component: () => import('@/components/hydro/dyn5')
      },

      //Властивості рідини
      {
        path: 'prp1',
        name: 'prp1',
        component: () => import('@/components/hydro/prp1')
      },
      {
        path: 'prp2',
        name: 'prp2',
        component: () => import('@/components/hydro/prp2')
      },
      {
        path: 'prp3',
        name: 'prp3',
        component: () => import('@/components/hydro/prp3')
      },
      {
        path: 'prp4',
        name: 'prp4',
        component: () => import('@/components/hydro/prp4')
      },
      {
        path: 'prp5',
        name: 'prp5',
        component: () => import('@/components/hydro/prp5')
      },
    ]
  },
  {
    path: '/fngp/',
    name: 'fngp',
    component: () => import('@/components/fngp/fngp'),
    children: [{
        path: 'fngp1',
        name: 'fngp1',
        component: () => import('@/components/fngp/fngp1')
      },
      {
        path: 'fngp2',
        name: 'fngp2',
        component: () => import('@/components/fngp/fngp2')
      },
      {
        path: 'fngp3',
        name: 'fngp3',
        component: () => import('@/components/fngp/fngp3')
      },
    ]
  },

  {
    path: '/tvg/',
    name: 'tvg',
    component: () => import('@/components/tvg/tvg'),
    children: [{
        path: 'tvg1',
        name: 'tvg1',
        component: () => import('@/components/tvg/tvg1')
      },
      {
        path: 'tvg2',
        name: 'tvg2',
        component: () => import('@/components/tvg/tvg2')
      },
      {
        path: 'tvg3',
        name: 'tvg3',
        component: () => import('@/components/tvg/tvg3')
      },
      {
        path: 'tvg4',
        name: 'tvg4',
        component: () => import('@/components/tvg/tvg4')
      },

      {
        path: 'tvgcom1',
        name: 'tvgcom1',
        component: () => import('@/components/tvg/tvgcom1')
      },
    ]
  },

  {
    path: '/equip/',
    name: 'equip',
    component: () => import('@/components/equip/equip'),
    children: [{
        path: 'equip1',
        name: 'equip1',
        component: () => import('@/components/equip/equip1')
      },
      {
        path: 'equip2',
        name: 'equip2',
        component: () => import('@/components/equip/equip2')
      },
      {
        path: 'equip3',
        name: 'equip3',
        component: () => import('@/components/equip/equip3')
      },
      {
        path: 'equip4',
        name: 'equip4',
        component: () => import('@/components/equip/equip4')
      },
    ]
  },

  {
    path: '/workover/',
    name: 'workover',
    component: () => import('@/components/workover/workover'),
    children: [{
        path: 'workover1',
        name: 'workover1',
        component: () => import('@/components/workover/workover1')
      },
      {
        path: 'workover2',
        name: 'workover2',
        component: () => import('@/components/workover/workover2')
      },
      {
        path: 'workover3',
        name: 'workover3',
        component: () => import('@/components/workover/workover3')
      },
      {
        path: 'workover4',
        name: 'workover4',
        component: () => import('@/components/workover/workover4')
      },
    ]
  },
  {
    path: '/drilling/',
    name: 'drilling',
    component: () => import('@/components/drilling/drilling'),
    children: [{
        path: 'drilling1',
        name: 'drilling1',
        component: () => import('@/components/drilling/drilling1')
      },
      {
        path: 'drilling2',
        name: 'drilling2',
        component: () => import('@/components/drilling/drilling2')
      },
      {
        path: 'drilling3',
        name: 'drilling3',
        component: () => import('@/components/drilling/drilling3')
      },
      {
        path: 'drilling4',
        name: 'drilling4',
        component: () => import('@/components/drilling/drilling4')
      },
      {
        path: 'drilling5',
        name: 'drilling5',
        component: () => import('@/components/drilling/drilling5')
      },
      {
        path: 'drilling6',
        name: 'drilling6',
        component: () => import('@/components/drilling/drilling6')
      },
      {
        path: 'drilling7',
        name: 'drilling7',
        component: () => import('@/components/drilling/drilling7')
      },
      {
        path: 'drilling8',
        name: 'drilling8',
        component: () => import('@/components/drilling/drilling8')
      },
      {
        path: 'drilling9',
        name: 'drilling9',
        component: () => import('@/components/drilling/drilling9')
      },
    ]
  },
  {
    path: '*',
    name: 'notfound',
    component: () => import('@/components/NotFound')
  }
];


export default new Router({
  routes: rts,
  mode: 'history',
})

export let pathnames = {
  'about': {
    ua: 'Зворотний зв\'язок'
  },
  'partners':{
    ua: 'Партнери'
  },
  'home': {
    ua: 'Головна'
  },
  'hydro': {
    ua: 'Гідравліка'
  },
  'hst1': {
    ua: 'Гідростатичний тиск стовпа рідини'
  },
  'hst2': {
    ua: 'Сила тиску на плоску поверхню'
  },

  'dyn': {
    ua: 'Гідродинаміка'
  },

  'dyn1': {
    ua: 'Лінійні втрати тиску в трубі круглого перерізу'
  },
  'dyn2': {
    ua: 'Лінійні втрати тиску в трубі кільцевого перерізу'
  },
  'dyn3': {
    ua: 'Визначення витрати під час витікання рідини через насадки і отвори'
  },
  'dyn4': {
    ua: 'Визначення напору перед насадкою'
  },
  'dyn5': {
    ua: 'Розрахунок величина підняття тиску під час гідравлічного удару'
  },

  'prp': {
    ua: 'Властивості рідин'
  },

  'prp1': {
    ua: 'Розрахунок густини рідини в залежності від температури'
  },
  'prp2': {
    ua: 'Визначення густини рідини за рахунок стиснення'
  },
  'prp3': {
    ua: 'Визначення густини суміші двох рідин'
  },
  'prp4': {
    ua: 'Ще задача'
  },
  'prp5': {
    ua: 'Ще задача'
  },

  'fngp': {
    ua: 'Фізика нафтового і газового пласта'
  },
  'fngp1': {
    ua: 'Паралельна однофазна фільтрація рідини за законом Дарсі. Формула Дарсі.'
  },
  'fngp2': {
    ua: 'Плоскорадіальна однофазна фільтрація рідини до свердловини за законом Дарсі. Формула Дюпюї'
  },
  'fngp3': {
    ua: "Коефіцієнт пружності насиченого нафтового пласта. П'єзопровідність нафтового пласта."
  },

  'tvg': {
    ua: 'Технологія видобування нафти і газу'
  },

  'tvg1': {
    ua: 'Cередньокритичні тиск і температура, стисливість газу за відносною густиною'
  },
  'tvg2': {
    ua: 'Розрахунок запасів газу газового покладу'
  },
  'tvg3': {
    ua: 'Визначення коефіцієнта надстисливості газу за приведеними параметрами'
  },
  'tvg4': {
    ua: 'Визначення густини газу за тиском і температурою'
  },
  'tvg5': {
    ua: 'Визначення вибійного тиску в зупиненій газовій свердловині'
  },

  'tvgcom1': {
    ua: 'Геотермальний градієнт. Пластова температура.'
  },

  'workover': {
    ua: 'Капітальний ремонт свердловин'
  },

  'workover1': {
    ua: 'Гідравлічний розрахунок оббурочної труби. Мінімальне навантаження на низ КНБК'
  },
  'workover2': {
    ua: 'Визначення рівня рідини глушіння для досягнення заданої величини депресії'
  },
  'workover3': {
    ua: 'Вага НКТ у свердловині'
  },
  'workover4': {
    ua: 'Приготування цементного розчину'
  },
  'workover5': {
    ua: 'КРС 5'
  },

  'drilling': {
    ua: 'Технологія буріння'
  },
  'drilling1': {
    ua: 'Розрахунок траєкторії свердловини за даними інклінометрії'
  },
  'drilling2': {
    ua: 'Гідравліка долота'
  },
  'drilling3': {
    ua: 'Визначення коефіцієнта аномальності пластового тиску'
  },
  'drilling4': {
    ua: 'Вага інструменту в розчині і технологічні об\'єми'
  },
  'drilling5': {
    ua: 'Погонна маса ОБТ за заданими діаметрами'
  },
  'drilling6': {
    ua: 'Обробка результатів випробування порід під башмаком колони на поглинання (Leakoff Test), перерахунок MAASP'
  },
  'drilling7': {
    ua: 'Визначення густини розчину глушіння при ГНВП'
  },
  'drilling8': {
    ua: 'Обважнення бурового розчину'
  },
  'drilling9': {
    ua: 'Допустимий устьовий тиск при випробуванні на міцність порід під башмаком ЕК (Leakoff Test)'
  },

  'notfound': {
    ua: 'Не знайдено'
  },
  'equip': {
    ua: 'Обладнання'
  },
  'equip1': {
    ua: 'Ідентифікація фланця за геометричними розмірами'
  },
  'equip2': {
    ua: 'Розрахунок подачі бурового насоса'
  },
  'equip3': {
    ua: 'Випробування протвикидного обладнання (ПВО) на герметичність з використанням манжетного випробувального пристрою (кап-тестер, test cup) '
  },
  'equip4': {
    ua: 'Обладнання 4'
  },
};


function checkiftranslatedname(name, listofnontranslated) {
  if (!(name in pathnames)) {
    listofnontranslated.push(name);
  }
}

function checkroutenametranslations() {
  // Перевірими чи всі імена компонентів мають перекладені імена:
  let lst = [];
  for (let i = 0; i < rts.length; i++) {
    checkiftranslatedname(rts[i]['name'], lst);

    if (rts[i].length > 0) {
      for (let j = 0; j < rts[i].length; j++) {
        checkiftranslatedname(rts[i][j]['name'], lst);
      }
    }
  }

  if (!(lst.length > 0)) {
    console.log('route names exist for every route and have been successfully exported');
  } else {
    console.log('these route names do not have matching human-friendly pathnames  ' + lst.length);
    for (let i = 0; i < lst.length; i++) {
      console.log(lst[i]);
    }
  }
}

checkroutenametranslations();



// WEBPACK FOOTER //
// ./src/router/index.js